import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import { Button, useVolatileCallback } from "@examspark/common-ui";

import { useAppContext } from "../../providers/AppContext";
import ApplicationError from "../ApplicationError";
import AppLoading from "../AppLoading";

type Props = {
  code: string | undefined;
  provider: string;
  onToken: (token: string) => void;
  onLogout?: () => void;
};

const LoginOidc = ({ code, provider, onLogout, ...props }: Props) => {
  const [error, setError] = useState(false);
  const [context] = useAppContext();

  const onToken = useVolatileCallback(props.onToken);

  const login = useCallback(async () => {
    if (code == null) return;
    if (context.app?.id == null) return;

    const url = new URL("/auth/oidc", process.env.REACT_APP_REST_API_URL);
    url.searchParams.set("appId", context.app?.id);
    url.searchParams.set("code", code);
    url.searchParams.set("provider", provider);

    try {
      const loginResponse = await axios<{ token: string }>({
        method: "POST",
        url: url.toString(),
        validateStatus: () => true,
      });

      if (loginResponse.status !== 200) {
        console.error(loginResponse.data);
        setError(true);
        return;
      }

      setError(false);
      onToken(loginResponse.data.token);
    } catch (e) {
      console.error(e);
      setError(true);
    }
  }, [code, context.app?.id, provider, onToken]);

  useEffect(() => {
    login();
  }, [login]);

  if (error) {
    return (
      <ApplicationError
        buttons={
          onLogout && (
            <Button title="Logout" onClick={onLogout}>
              Clear Cache and Logout
            </Button>
          )
        }
      />
    );
  }

  return <AppLoading />;
};

export default LoginOidc;
